//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//Data
import VdoCipherComp from "../../Components/VdoCipher/VdoCipher";

const ET6Video: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="ET6" />
            <SubSection>
                <VdoCipherComp filename="et6" />
            </SubSection>
        </div>
    );
};

export default ET6Video;